import type { ICountry, IListResponse } from '@dakedake/types'
import { request } from '@umijs/max'

/** 添加国家 POST /backend/country/add */
export async function countryAdd(body: ICountry, options?: Record<string, any>) {
  return request<{ data: ICountry, success: boolean, message: string }>('/backend/country/add', {
    method: 'POST',
    data: body,
    ...options
  })
}

/** 删除国家 POST /backend/country/delete */
export async function countryDelete(body: { id: number }, options?: Record<string, any>) {
  return request<{ data: ICountry, success: boolean, message: string }>('/backend/country/delete', {
    method: 'DELETE',
    data: body,
    ...options
  })
}

/** 获取国家列表 GET /backend/country/list */
export async function countryList(
  params: {
    // query
    /** 当前的页码 */
    current?: number
    /** 页面的容量 */
    pageSize?: number
  },
  options?: Record<string, any>
) {
  return request<IListResponse<ICountry>>('/backend/country/list', {
    method: 'GET',
    params: {
      ...params
    },
    ...options
  })
}
